export default "__VITE_ASSET__0af14281__"